// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"02feb0e2","778":"4938baad"}[chunkId] + ".css";
};